import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.97 15.758l-5.855 5.88c-.258.242-.55.362-.877.362-.327 0-.615-.125-.864-.374A1.2 1.2 0 0 1 0 20.749c0-.335.12-.623.361-.864l5.88-5.855a7.493 7.493 0 0 0 1.729 1.728zm12.689-7.685c0-1.857-.658-3.443-1.973-4.759C17.37 2 15.784 1.341 13.927 1.341c-1.874 0-3.456.662-4.745 1.986-1.307 1.324-1.96 2.906-1.96 4.746 0 1.822.653 3.404 1.96 4.745 1.29 1.307 2.871 1.96 4.745 1.96 1.857 0 3.443-.657 4.759-1.973C20 11.49 20.659 9.912 20.659 8.073zM8.24 2.36A8.131 8.131 0 0 1 10.807.632 7.819 7.819 0 0 1 13.927 0c2.236 0 4.136.782 5.7 2.347.74.74 1.32 1.6 1.741 2.58A7.85 7.85 0 0 1 22 8.06a7.85 7.85 0 0 1-.632 3.133 8.131 8.131 0 0 1-1.728 2.567 8.131 8.131 0 0 1-2.566 1.728 7.85 7.85 0 0 1-3.134.632 7.85 7.85 0 0 1-3.133-.632A8.131 8.131 0 0 1 8.24 13.76a8.313 8.313 0 0 1-1.74-2.567 7.715 7.715 0 0 1-.645-3.133c0-1.11.215-2.154.644-3.134A8.313 8.313 0 0 1 8.24 2.36z"
    }, null, -1)
  ])))
}
export default { render: render }